import { render, staticRenderFns } from "./TokenPrice.vue?vue&type=template&id=024d2f60&scoped=true&"
import script from "./TokenPrice.vue?vue&type=script&lang=js&"
export * from "./TokenPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d2f60",
  null
  
)

export default component.exports